import { render } from "./EditPartenaire.vue?vue&type=template&id=1ee4eda2&ts=true"
import script from "./EditPartenaire.vue?vue&type=script&lang=ts"
export * from "./EditPartenaire.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__